<template>
  <div class="modal-header">
    <v-icon
      size="large"
      class="header-icon header-icon-main"
      v-if="!modalSubtitle && !helpFileName"
      style="margin-right: 16px; margin-left: 4px">
      {{ icon }}
    </v-icon>
    <v-icon
      size="x-large"
      class="header-icon header-icon-main"
      v-else
      style="margin-right: 16px">
      {{ icon }}
    </v-icon>
    <div
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
      "
      :style="!modalSubtitle && !helpFileName ? 'align-items: center' : ''">
      <slot name="title">
        <div
          class="header-title"
          style="
            font-weight: bold;
            max-width: 310px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 12px;
          ">
          {{ modalTitle }}
        </div>
      </slot>
      <div
        v-if="modalSubtitle"
        class="header-subtitle"
        style="opacity: 0.6; font-size: 10px">
        {{ modalSubtitle }}
      </div>
    </div>
    <slot name="iconContainer"></slot>
    <v-spacer />
    <HelpButton
      v-if="helpFileName"
      :mdxName="helpFileName" />
    <div
      v-if="!hideCloseBtn"
      title="Close this dialog window"
      @click="emit('close')"
      class="ibtn-container mr-2 pa-1 header-icon header-icon-right">
      <v-icon class="header-icon">mdi-close-circle</v-icon>
    </div>
    <slot name="iconContainer2"></slot>
  </div>
</template>
<script setup>
import { defineProps } from 'vue';
import HelpButton from '../../Help-Hints/HelpButton.vue';

const props = defineProps([
  'icon',
  'modalTitle',
  'modalSubtitle',
  'helpFileName',
  'hideCloseBtn',
]);
const emit = defineEmits(['close']);
</script>
<style scoped>
.modal-header {
  margin: 18px;
  margin: 12px 18px 22px;
  display: flex;
  flex-wrap: nowrap;
  color: #2d2d2d;
  font-size: 15px;
  margin-bottom: 22px;
  padding-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--text);
}
</style>
